import { ApolloError } from '@apollo/client';
import get from 'lodash/get';
import { NavigateFunction } from 'react-router-dom';
import { Dispatch } from 'redux';

import { completedNavigatorStep } from 'analytics/navigator';
import { StepName } from 'analytics/navigator/constants';
import { frontendAnalyticsTrack } from 'analytics/utils';
import { addGlobalError, stopLoader, updateActiveIds } from 'containers/App/actions';
import { DEFAULT_GLOBAL_ERROR_MESSAGE, SUBMISSION_ERROR_MESSAGE } from 'containers/App/constants';
import consolidateKnownErrors from 'graphql/util/consolidateKnownErrors';
import { HOUSEHOLD_FULL_PATH } from 'routes/constants';

import { CREATED_DISGUISE_EVENT } from './constants';

interface CompleteOptions {
  activeUserUuid: string;
  dispatch: Dispatch;
  navigate: NavigateFunction;
}

export const basicInfoMutationComplete = ({
  activeUserUuid,
  dispatch,
  navigate,
}: CompleteOptions) => {
  completedNavigatorStep(StepName.BASIC_INFO, activeUserUuid);
  navigate(HOUSEHOLD_FULL_PATH);
  dispatch(stopLoader());
};

export const basicInfoMutationError = (error: ApolloError, dispatch: Dispatch) => {
  dispatch(stopLoader());
  const definedErrors = get(error, 'networkError.result.errors') || consolidateKnownErrors(error);

  dispatch(addGlobalError(definedErrors ? SUBMISSION_ERROR_MESSAGE : DEFAULT_GLOBAL_ERROR_MESSAGE));
  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: 0,
  });

  throw error;
};

// TODO: Move to SelectUser
export const createNewSpousalAppComplete =
  (activeUserUuid: string, dispatch: Dispatch) => (data: any) => {
    const newApp = get(data, 'customers.create_new_spousal_app', {});
    const newCustomer = newApp.customer;
    const newLifeApplication = newApp.life_application;

    trackCreatedDisguise(newCustomer.uuid, 'basics', activeUserUuid);

    dispatch(
      updateActiveIds({
        activeUserUuid: newCustomer.uuid,
        activeLifeApplicationId: newLifeApplication.id,
      })
    );

    dispatch(stopLoader());
  };

const trackCreatedDisguise = (disguiseUuid: string, triggeredFrom: string, userId: string) => {
  frontendAnalyticsTrack(CREATED_DISGUISE_EVENT, {
    disguise_uuid: disguiseUuid,
    triggered_from: triggeredFrom,
    user_id: userId,
  });
};
